export default __webpack_public_path__ + "static/mockup2_save-a9bded87e09675af26e6019ad902a3d7.jpg";